import { FC, useMemo } from "react";
import { Box, Stack } from "@mui/material";
import { readDataByDotSeparatedString } from "../../../../ag-grid/utils/helpers/readDataByDotSeparatedString";
import type { ICellRendererParams } from "ag-grid-community";
import { useHover } from "@/utils/hooks/useHover.hook";
import { CopyIconButton } from "@/components/common/CopyIconButton";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";

export const ResourceGridDefaultCellRenderer: FC<ICellRendererParams> = ({
  data,
  column,
}) => {
  const { ref, hovered } = useHover();

  const colId = column?.getColId() ?? "";
  const noData = column?.getColDef()?.cellRendererParams?.noData;

  const value = useMemo(
    () => readDataByDotSeparatedString(colId, data),
    [colId, data],
  );

  if (!value) {
    const noDataResult = typeof noData === "function" ? noData?.() : noData;

    return noDataResult ?? "-";
  }

  return (
    <Box ref={ref} sx={{ whiteSpace: "nowrap" }}>
      <Stack direction="row" alignItems="center">
        <TypographyWithTooltip title={value} variant="body2" />

        <CopyIconButton data={value} visible={hovered} />
      </Stack>
    </Box>
  );
};
